'use client'

import * as React from 'react'
import {
  BookOpen,
  Bot,
  Brain,
  Settings2,
  SquareTerminal,
  FileText,
  Users,
  BarChart3,
} from 'lucide-react'
import { Link } from '@tanstack/react-router'

import { NavMain } from '@/components/nav-main'
import { NavProjects } from '@/components/nav-projects'
import { NavSecondary } from '@/components/nav-secondary'
import { NavUser } from '@/components/nav-user'
import { UniversalSearch } from '@/components/universal-search'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'

const data = {
  navMain: [
    {
      title: 'Playground',
      url: '/dashboard',
      icon: SquareTerminal,
      isActive: true,
      items: [
        {
          title: 'Chat',
          url: '/dashboard/chat',
        },
        {
          title: 'History',
          url: '/dashboard/history',
        },
        {
          title: 'Favorites',
          url: '/dashboard/favorites',
        },
      ],
    },
    {
      title: 'AI Models',
      url: '/dashboard/models',
      icon: Bot,
      items: [
        {
          title: 'GPT-4',
          url: '/dashboard/models/gpt4',
        },
        {
          title: 'Claude',
          url: '/dashboard/models/claude',
        },
        {
          title: 'Gemini',
          url: '/dashboard/models/gemini',
        },
      ],
    },
    {
      title: 'Knowledge Base',
      url: '/dashboard/knowledge',
      icon: BookOpen,
      items: [
        {
          title: 'Documents',
          url: '/dashboard/knowledge/documents',
        },
        {
          title: 'Sources',
          url: '/dashboard/knowledge/sources',
        },
        {
          title: 'Training',
          url: '/dashboard/knowledge/training',
        },
      ],
    },
    {
      title: 'Settings',
      url: '/dashboard/settings',
      icon: Settings2,
      items: [
        {
          title: 'General',
          url: '/dashboard/settings/general',
        },
        {
          title: 'API Keys',
          url: '/dashboard/settings/api',
        },
        {
          title: 'Billing',
          url: '/dashboard/settings/billing',
        },
        {
          title: 'Usage',
          url: '/dashboard/settings/usage',
        },
      ],
    },
  ],
  navSecondary: [],
  projects: [
    {
      name: 'Research Assistant',
      url: '/dashboard/projects/research',
      icon: FileText,
    },
    {
      name: 'Content Creation',
      url: '/dashboard/projects/content',
      icon: BarChart3,
    },
    {
      name: 'Team Collaboration',
      url: '/dashboard/projects/team',
      icon: Users,
    },
  ],
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar variant="inset" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" className="px-0" asChild>
              <Link to="/dashboard">
                <div className="bg-white text-black dark:bg-white dark:text-black flex size-12 items-center justify-center rounded-full">
                  <Brain className="size-8" />
                </div>
                <div className="grid flex-1 text-left leading-tight text-left">
                  <div className="flex items-center">
                    <span className="text-lg font-mono font-bold dark:font-normal">
                      ThoughtFabric
                    </span>
                  </div>
                  <span className="text-[11px] font-mono font-bold text-muted-foreground dark:font-normal">
                    All in one AI Workspace
                  </span>
                </div>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
        <div className="px-3 mt-2">
          <UniversalSearch />
        </div>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
        <NavProjects projects={data.projects} />
        <NavSecondary items={data.navSecondary} className="mt-auto" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
